/* eslint-disable no-magic-numbers */
import { memoize } from "decko";

export default class Texts {
  static replaceVars(text, replacements = {}) {
    let newText = text || "";

    Object.keys(replacements).forEach((prop) => {
      newText = newText.replace(new RegExp(`{{${prop}}}`, "g"), replacements[prop]);
    });

    return newText;
  }

  @memoize
  static capitalize(text) {
    if (!text) return null;

    return text[0].toUpperCase() + text.substring(1);
  }

  @memoize
  static uncapitalize(text) {
    if (!text) return null;

    return text[0].toLowerCase() + text.substring(1);
  }

  @memoize
  static shorten([text, maxLength, joiner = "..."]) {
    if (!text) return "";
    if (!maxLength || text.length <= maxLength) return text;

    const length = Math.floor((maxLength - joiner.length) / 2);

    return `${text.slice(0, length)}${joiner}${text.slice(-length)}`;
  }

  @memoize
  static escapeRegexp(text) {
    return text.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
}
